import { FC, memo } from 'react';

const BookmarkIcon: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 27H7.25V28.7884L8.52566 27.535L8 27ZM16 19.139L16.5257 18.6041L16 18.0876L15.4743 18.6041L16 19.139ZM24 27L23.4743 27.535L24.75 28.7884V27H24ZM7.25 9.70588V27H8.75V9.70588H7.25ZM8.52566 27.535L16.5257 19.674L15.4743 18.6041L7.47434 26.465L8.52566 27.535ZM15.4743 19.674L23.4743 27.535L24.5257 26.465L16.5257 18.6041L15.4743 19.674ZM24.75 27V9.70588H23.25V27H24.75ZM20.5714 5.25H11.4286V6.75H20.5714V5.25ZM24.75 9.70588C24.75 7.30096 22.9331 5.25 20.5714 5.25V6.75C21.9969 6.75 23.25 8.0174 23.25 9.70588H24.75ZM8.75 9.70588C8.75 8.0174 10.0031 6.75 11.4286 6.75V5.25C9.06695 5.25 7.25 7.30096 7.25 9.70588H8.75Z" fill={fill} />
    </svg>
  );
}

export default memo(BookmarkIcon);
import { FC, memo } from 'react';

const BookmarkIcon: FC<{ fill: string}> = ({ fill }) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 27H7.25V28.7884L8.52566 27.535L8 27ZM16 19.139L16.5257 18.6041L16 18.0876L15.4743 18.6041L16 19.139ZM24 27L23.4743 27.535L24.75 28.7884V27H24ZM7.25 9.70588V27H8.75V9.70588H7.25ZM8.52566 27.535L16.5257 19.674L15.4743 18.6041L7.47434 26.465L8.52566 27.535ZM15.4743 19.674L23.4743 27.535L24.5257 26.465L16.5257 18.6041L15.4743 19.674ZM24.75 27V9.70588H23.25V27H24.75ZM20.5714 5.25H11.4286V6.75H20.5714V5.25ZM24.75 9.70588C24.75 7.30096 22.9331 5.25 20.5714 5.25V6.75C21.9969 6.75 23.25 8.0174 23.25 9.70588H24.75ZM8.75 9.70588C8.75 8.0174 10.0031 6.75 11.4286 6.75V5.25C9.06695 5.25 7.25 7.30096 7.25 9.70588H8.75Z" fill={fill} />
    </svg>
  );
}

export default memo(BookmarkIcon);
